module.exports = __webpack_public_path__ + "static/img/vip.adeafe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/manman/images/vip.png
// module id = lo38
// module chunks = 21